














import { Component, Vue } from 'vue-property-decorator'
import TaggedKycSection from '../TaggedKycSection.vue'
import UploadApplicationDocumentSection from '../UploadApplicationDocumentSection.vue'
import ExistingDocumentSection from '../ExistingDocumentSection.vue'
import { namespace } from 'vuex-class'
import { ClientPolicyDto, PolicyIndividualDTO } from '@core/pages/CommissionModule/api'

const clientPolicyStore = namespace('ClientPolicyStore')

@Component({
  components: {
    TaggedKycSection,
    UploadApplicationDocumentSection,
    ExistingDocumentSection
  }
})
export default class SubmittedDocumentPage extends Vue {
  @clientPolicyStore.State
  policy: ClientPolicyDto

  @clientPolicyStore.State
  policyIndividuals: PolicyIndividualDTO[]

  get mainOwner () {
    return this.policyIndividuals.find(individual => individual.isMainOwner)
  }
}
